/**
 * Checks if a URL should be visible based on user permissions
 * This function uses the tree view's visible URLs (already filtered by permissions)
 * @param {string} url - The URL to check
 * @param {Object} permissions - User permissions (not used directly, but kept for compatibility)
 * @param {Set|Array} treeViewVisibleUrls - Visible URLs from tree view (already filtered by permissions)
 */
export const checkUrlPermission = (url, permissions, treeViewVisibleUrls) => {
    if (!url) return false;

    // Home and logout are always accessible
    if (url === "/home" || url === "/") return true;

    // Extract the path without query parameters
    const path = url.split('?')[0].toLowerCase();
    
    // If treeViewVisibleUrls is provided (from Redux), use it directly
    // These URLs are already filtered by permissions in the tree view
    if (treeViewVisibleUrls) {
        if (treeViewVisibleUrls instanceof Set) {
            return treeViewVisibleUrls.has(path);
        } else if (Array.isArray(treeViewVisibleUrls)) {
            return treeViewVisibleUrls.includes(path);
        }
    }
    
    // Fallback: if tree view URLs are not available, return false
    // This ensures we only show URLs that are in the tree view
    return false;
};

/**
 * Filters an array of search results to only include URLs the user has permission for
 * @param {Array} results - Search results to filter
 * @param {Object} permissions - User permissions (kept for compatibility)
 * @param {Set|Array} treeViewVisibleUrls - Visible URLs from tree view (already filtered by permissions)
 */
export const filterResultsByPermission = (results, permissions, treeViewVisibleUrls) => {
    if (!results || !Array.isArray(results)) return [];
    
    return results.filter(item => {
        const url = item.url || item.value;
        if (!url) return false;
        
        return checkUrlPermission(url, permissions, treeViewVisibleUrls);
    });
};
